module.exports = __webpack_public_path__ + "img/joy_stick_top.0ab8d1c1.png";